import { render } from "./PrinterControls.vue?vue&type=template&id=4850e080&scoped=true"
import script from "./PrinterControls.vue?vue&type=script&lang=js"
export * from "./PrinterControls.vue?vue&type=script&lang=js"

import "./PrinterControls.vue?vue&type=style&index=0&id=4850e080&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4850e080"]])

export default __exports__